import { Select } from 'antd';
import { filterOption } from '@/std/filter';
import type { ProdutoTipoFiscal } from '../types/ProdutoTipoFiscal';
import { useProdutoTipoQuery } from '../api/apiProdutoTipo';

export function ProdutoTipoFiscalSelect({
    value,
    disabled,
    onChange,
}: {
    value?: string;
    disabled?: boolean;
    onChange?: (tipoFiscal: ProdutoTipoFiscal | null) => void;
}) {
    const { data, isFetching } = useProdutoTipoQuery();

    const options = data?.registros.map((item) => ({
        label: `${item.prt_codigo} - ${item.prt_descricao}`,
        value: item.prt_codigo,
    }));

    const handleChange = (prt_codigo: string | undefined): void => {
        if (!onChange) {
            return;
        }

        if (!prt_codigo) {
            onChange(null);
            return;
        }

        const tipoFiscal = data?.registros.find((item) => item.prt_codigo === prt_codigo);
        onChange(tipoFiscal || null);
    };

    return (
        <Select
            allowClear={true}
            className='w-full'
            disabled={disabled}
            loading={isFetching}
            onChange={handleChange}
            options={options}
            showSearch={{ filterOption }}
            value={value}
        />
    );
}
